/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_MASSUPLOAD_URL, COMMON_HEADER_CONFIG} from "src/config";

class CodReportService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListCodReport = ({signal, ...params}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MASSUPLOAD_URL}/dwh/list-daily-sale-report`,
        params,
        signal,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const codReportService = new CodReportService();

export default codReportService;
